<template>
    <form class="form">
        <!-- Moment box -->
        <div class="row">
            <div class="col-12 col-md-12 col-l-12 col-xl-10">
                <div class="block has-no-bottom-margin">
                    <!-- Input form -->
                    <div>
                        <div class="row">
                            <div class="col-12">
                                <h4 class="has-no-margin" v-html="title"></h4>
                                <span class="text-italic">{{$t('form.appointment.header_multiple_allowed')}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-xxl-7" style="text-align: center">
                                <datepicker class="datepicker" v-model="editorMoment.date" :inline="true" :highlighted="highlightedDates" :disabled-dates="{to: new Date()}"></datepicker>
                            </div>
                            <div class="col-12 col-xxl-5">
                                <p><strong>{{$t('form.appointment.header_slots')}}</strong></p>

                                <div class="checkbox" v-for="slot in slots">
                                    <input class="checkbox__cb" :id="slot" type="checkbox"
                                           v-model="editorMoment.slots[slot]"/>
                                    <label class="checkbox__label--emph" :for="slot">
                                        {{$t('form.appointment.label_' + slot)}}
                                        <span>{{$t('form.appointment.label_' + slot + '_time')}}</span>
                                    </label>
                                </div>
                                <button type="button" class="button--cta" @click="addMoment" :disabled="!canAdd">
                                    {{$t('form.appointment.add_date')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <table class="table--list">
                    <tbody>
                        <tr v-for="(value, key, index) in moments">
                            <td class="table__cell--date">
                                <p>{{$t('form.appointment.label_moment_date')}}</p>
                                <span>{{formatDate(key)}}</span>
                                <div class="table__row visible-xs">
                                    <br/>
                                    <p>{{$t('form.appointment.label_moment_slots')}}</p>
                                    <span>{{formatSlots(value)}}</span>
                                </div>
                            </td>
                            <td class="hidden-xs">
                                <p>{{$t('form.appointment.label_moment_slots')}}</p>
                                <span>{{formatSlots(value)}}</span>
                            </td>
                            <td>
                                <a @click.stop="removeMoment(key)"  v-tooltip="$t('common.button.remove')"
                                   class="button--icon">
                                    <i class="mdi mdi-trash-can"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--show address-->
        <div class="row">
            <div class="col-12 col-md-12 col-l-12 col-xl-5">
                <div class="block has-no-top-margin">
                    <h4>{{$t('form.appointment.address')}}</h4>
                    <p v-for="(value, key) in address">
                        <b>{{$t('form.appointment.label_' + key)}} : </b> {{value}}
                    </p>
                </div>
            </div>
            <div class="col-12 col-md-12 col-l-12 col-xl-5">
                <div class="block has-no-top-margin">
                    <h4>{{$t('form.appointment.label_comment')}}</h4>
                    <textarea class="block__textarea form__input--textarea border_dark" v-model="comment"
                              :placeholder="$t('form.appointment.placeholder_comment')"></textarea>
                </div>
            </div>
        </div>
        <!--show buttons-->
        <div class="row">
            <div class="col-12 col-md-12 col-l-12 col-xl-10"> 
                <div class="form__buttons pull-right">
                    <button type="submit" class="button--cta has-no-margin-right" :disabled="!canSubmit" @click.prevent="$emit('submit', comment)">
                        {{$t('form.appointment.button_submit')}}
                    </button>
                    <button class="button pull-left has-smaller-horizontal-padding" :disabled="busy" @click.prevent="$emit('back')">
                        {{$t('common.button.go_back')}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import moment from 'moment';
    import Datepicker from '../general/Datepicker';
    import {
        CLEAR_MOMENTS,
        GET_MOMENTS,
        REMOVE_MOMENT,
        ADD_MOMENT,
    } from '../../store/modules/moments';
    import {FETCH_ACCOUNT_DETAILS, GET_FIELD} from '../../store/modules/account_details';

    export const SLOT_MORNING = 'morning';
    export const SLOT_AFTERNOON = 'afternoon';

    @Component({
        components: {Datepicker},
    })
    export default class MomentsForm extends Vue {
        @Prop({type: String})
        title;

        @Prop({type: Boolean, default: false})
        busy;

        editorMoment = {
            date: moment().add(1, 'days').toDate(),
            slots: {
                [SLOT_MORNING]: true,
                [SLOT_AFTERNOON]: true,
            },
        };

        comment = '';

        slots = [SLOT_MORNING, SLOT_AFTERNOON]
        address = {
            street: '',
            number: '',
            postalCode: '',
            city: '',
            country: ''
        }


        created(){
            window.scrollTo(0,0);
            this.$store.dispatch(CLEAR_MOMENTS);
            this.setAddress();
        }

        async setAddress(){
            if (this.getFieldValue('address') === 'address'){
                await this.$store.dispatch(FETCH_ACCOUNT_DETAILS);
            }
            this.address.street = this.getFieldValue('address');
            this.address.number = this.getFieldValue('address_number');
            this.address.postalCode = this.getFieldValue('postal_code');
            this.address.city = this.getFieldValue('city_name');
            this.address.country = this.getFieldValue('country_name');
        }

        getFieldValue(field){
            return this.$store.getters[GET_FIELD](field);
        }

        get moments(){
            return this.$store.getters[GET_MOMENTS];
        }

        get highlightedDates(){
            let hightlightedDates = {
                dates: []
            };
            if (Object.keys(this.moments).length > 0){
                let keys = Object.keys(this.moments);
                for (let i = 0; i < keys.length; i ++){
                    hightlightedDates.dates.push(new Date(keys[i]));
                }
            }
            return hightlightedDates;

        }

        addMoment(){
            if (!this.canAdd) return;
            const date = this.editorMoment.date;
            const times = [];

            for (const [key, value] of Object.entries(this.editorMoment.slots)){
                if (value === true){
                    times.push(key);
                }
            }
            const key = moment(date).format('YYYY-MM-DD');
            this.$store.dispatch(ADD_MOMENT, {key, times});
            this.$forceUpdate();
        }

        removeMoment(key) {
            this.$store.dispatch(REMOVE_MOMENT, key);
            this.$forceUpdate();
        }

        formatDate(key){
            return moment(key).format('dddd LL');
        }


        formatSlots(items) {
            let translation = '';
            if (!items) return undefined;
            for (let i = 0; i < items.length; i++) {
                translation = translation + this.$t('form.appointment.label_' + items[i]) + ', ';
            }
            translation = translation.substr(0, translation.length-2);
            return translation;
        }

        get canAdd() {
            if (!this.busy){
                return this.editorMoment.slots[SLOT_AFTERNOON] === true || this.editorMoment.slots[SLOT_MORNING] === true;
            } return false;
        }

        get canSubmit() {
            if (!this.busy && Object.keys(this.moments).length > 0) {
                return true;
            }
            return false;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/MomentsForm.vue